export const BASE_API_URL = process.env.REACT_APP_API || 'http://localhost:1081/api/widgets';
export const WIDGET_SCRIPT_ID = 'widgetScript';
export const TG_WIDGET_ACCESS_TOKEN = 'tg_widget_access_token';
export const TG_WIDGET_JWT = 'tg_widget_jwt';
export const TG_WIDGET_MEMBER_ID = 'tg_widget_member_id';
export const TG_WIDGET_THEME = 'tg_widget_theme';
export const TG_WIDGET_MEMBER_DATA = 'tg_widget_member';
export const TG_WIDGET_REVIEW_SCHEMES = 'tg_widget_review_schemes';
export const TG_WIDGET_BRANDING = 'tg_widget_branding';
export const TG_WIDGET_HEADER_FOOTER = 'tg_widget_header_footer';
export const TG_WIDGET_WEBSITE_USER_ID = 'tg_widget_website_user_id';
export const TG_WIDGET_DOMAIN_OWNER_ID = 'tg_widget_domain_owner_id';
export const TG_WIDGET_X_THEME = 'tg_widget_x_theme';

export const DEFAULT_SITE_NAME = 'apfm';